/**
 * ToolsPage - Wrapper for the old HomePage component.
 * Accessible at "/tools" route.
 */
import HomePage from '../HomePage';

const ToolsPage = HomePage;

export default ToolsPage;
